import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aba20c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "input-group mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins" })
], -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt" })
], -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie" })
], -1))
const _hoisted_12 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-message" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-bell me-2" }),
    /*#__PURE__*/_createTextVNode("เกิดข้อผิดพลาด!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "กรุณาติดต่อผู้ดูแลระบบเพื่อกำหนดหน้าที่รับผิดชอบก่อน")
], -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_VueSelect = _resolveComponent("VueSelect")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.assigned)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected.fiscalYearId) = $event)),
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fiscalYearChange && _ctx.fiscalYearChange(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiscalYears, (fiscalYear) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: fiscalYear.id,
                          value: fiscalYear.id
                        }, _toDisplayString(fiscalYear.name), 9, _hoisted_5))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.selected.fiscalYearId]
                    ])
                  ])
                ]),
                (_ctx.cabinets.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cabinetId) = $event)),
                          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cabinetChange && _ctx.cabinetChange(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabinets, (cabinet) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: cabinet.id,
                              value: cabinet.id
                            }, _toDisplayString(_ctx.cabinetLabel(cabinet)), 9, _hoisted_9))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.cabinetId]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.cabinets.length > 1 ? 'col-sm-12' : 'col-sm-6')
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_VueSelect, {
                      class: "form-control p-0",
                      modelValue: _ctx.selected.ministerId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected.ministerId) = $event)),
                      options: _ctx.ministers,
                      clearable: false,
                      label: "name",
                      reduce: m => m.id,
                      placeholder: "กรุณาเลือก ร.นรม./รมต.นร."
                    }, null, 8, ["modelValue", "options", "reduce"])
                  ])
                ], 2)
              ]),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      ], 64))
}